import { Navigate, useParams } from 'react-router-dom';

import { useGetMarcaProducto } from '@/shared/actions/erp';
import { LoaderComponent } from '@/shared/components/ui';
import { SaveMarcaProducto } from '../../shared/saveMarcasProduct';
import { ROUTER_PATHS, useCheckPermissions } from '@/shared';
import { PermissionsEnum } from '@/auth/interfaces';

export interface UpdateMarcasProductosPageInterface {}

const UpdateMarcasProductosPage: React.FC<UpdateMarcasProductosPageInterface> = () => {
  useCheckPermissions(PermissionsEnum.api_change_marca_producto)

  const { id } = useParams();
  const { data, isLoading } = useGetMarcaProducto(id!);

  if (isLoading) return <LoaderComponent />;
  if (!data?.data?.id_marca) return <Navigate to={ROUTER_PATHS.inventario.marca_productos_editar} />;

  return <SaveMarcaProducto titlePage="Editar marca producto" editMarcaProductos={data.data} />;
};

export default UpdateMarcasProductosPage;
